import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import './Spotify.css';

const authEndpoint = 'https://accounts.spotify.com/authorize';
// http://weatherfy.net
// http://localhost:3000
const redirectUri = 'http://localhost:3000';
const scopes = [
    'user-read-currently-playing',
    'user-read-playback-state',
];

const Spotify = (props: any) => {
    const { setUserToken } = props;
    const [token, setToken] = useState('');

    useEffect(() => {
        const hash: any = window.location.hash;
        let newToken: any = window.localStorage.getItem("token") || null;

        if (!newToken && hash) {
            newToken = hash.substring(1).split("&").find((elem: any) => elem.startsWith("access_token")).split("=")[1]
    
            window.location.hash = ""
            window.localStorage.setItem("token", newToken)
        }

        setToken(newToken);
        setUserToken(newToken);
    }, [])

    const logout = () => {
        window.localStorage.removeItem("token")
        setToken('')
        setUserToken('');
    }

    return (
        <div>
            {!token &&
                <div>
                    <h1 className='spotify-main-header'>
                        The perfect playlist for any weather.
                    </h1>
                    <h2 className='spotify-sub-header'>
                        Weatherfy uses location data to look up the weather
                        in the area and smartly matches it to a Spotify playlist.
                    </h2>
                    <h2 className='spotify-sub-header'>
                        To get started, connect your Spotify account below.
                    </h2>
                    <div className='spotify-btn-container'>
                        <a
                            className='link'
                            href={`${authEndpoint}?client_id=${process.env.REACT_APP_SPOTIFY_KEY}&redirect_uri=${redirectUri}&scope=${scopes.join("%20")}&response_type=token`}
                        >
                            <Button variant="contained">Login to Spotify</Button>
                        </a>
                    </div>
                </div>
            }
            {token &&
                <div>
                    <div className='step-complete'>
                        ✅ Spotify account successfully connected
                        <span onClick={logout} className='disconnect'>DISCONNECT</span>
                    </div>
                </div>
            }
        </div>
    );
}

export default Spotify;